import "../css/Featured.css";
import axiosInstance from "../api/axiosConfig";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import addToCart from "../redux/toggleCart";
import AddToCartButton from "./AddToCartButton";

export default function FeaturedProducts() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const dispatch = useDispatch();

  const getFeaturedProducts = async () => {
    const response = await axiosInstance.get("/products?featured=true"); // LLAMADA AXIOS PARA RECIBIR LOS PRODUCTOS DESTACADOS
    if (response.status !== 200) return;
    setFeaturedProducts(response.data);
  };

  useEffect(() => {
    getFeaturedProducts();
  }, []);

  return (
    <div>
      <section className="veg_section layout_padding">
        <div className="container">
          <div className="heading_container heading_center">
            <h2>Featured Products</h2>
            <p>
              We believe you get out what you put in - which is why our certified manufacturing
              facilities only use high quality ingredients and strict quality control when making
              our products.
            </p>
          </div>
          <div className="row">
            {featuredProducts.map((product) => {
              return (
                <div key={product.id} className="col-md-6 col-lg-4">
                  <div className="box">
                    <Link to={`/product/${product.slug}`}>
                      <div className="img-box">
                        <img
                          src={process.env.REACT_APP_IMG_BASE_URL + product.image}
                          alt={product.name}
                        />
                      </div>
                      <div className="detail-box text-dark">
                        {product.name}

                        <div className="price_box">
                          <h6 className="price_heading">
                            <span>US$</span> <span className="text-dark">{product.price}</span>
                          </h6>
                        </div>
                      </div>
                    </Link>
                    <AddToCartButton
                      product={product}
                      quantityToAdd={1}
                      hasFormBeenSubmitted={false}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
